import type { Role } from "@/context/BranchContext";

export type RoleTier = "staff" | "management";

export interface RoleMeta {
  key: Role;
  /** الاسم الكامل للمسمى الوظيفي */
  label: string;
  /** الاسم المختصر المستخدم في الشارات */
  short: string;
  icon: string;
  /** صنف شارة الدور (خلفية صلبة) */
  badgeClass: string;
  tier: RoleTier;
}

/**
 * المسمّيات الوظيفية الخمسة الرسمية في لوحة الفرع.
 * المسمى هو عنوان وظيفي فقط للعرض — ولا يرتبط بأي صلاحيات ثابتة أو تلقائية.
 * صاحب المحل هو من يحدد صلاحيات كل موظف من لوحة الموظفين.
 */
export const ROLE_META: Record<Role, RoleMeta> = {
  cashier: {
    key: "cashier",
    label: "كاشير (أمين صندوق)",
    short: "كاشير",
    icon: "ri-user-star-line",
    badgeClass: "bg-primary-500 text-background-50",
    tier: "staff",
  },
  shift_supervisor: {
    key: "shift_supervisor",
    label: "مشرف شفت (فترة)",
    short: "مشرف شفت",
    icon: "ri-user-follow-line",
    badgeClass: "bg-secondary-500 text-background-50",
    tier: "staff",
  },
  operations: {
    key: "operations",
    label: "مسؤول عمليات",
    short: "مسؤول عمليات",
    icon: "ri-user-settings-line",
    badgeClass: "bg-accent-500 text-foreground-900",
    tier: "staff",
  },
  branch_manager: {
    key: "branch_manager",
    label: "مدير فرع",
    short: "مدير فرع",
    icon: "ri-store-2-line",
    badgeClass: "bg-primary-700 text-background-50",
    tier: "management",
  },
  owner: {
    key: "owner",
    label: "مشرف عام / مالك فروع",
    short: "مشرف عام",
    icon: "ri-shield-user-line",
    badgeClass: "bg-foreground-900 text-white",
    tier: "management",
  },
};

export const ROLE_LIST: RoleMeta[] = [
  ROLE_META.cashier,
  ROLE_META.shift_supervisor,
  ROLE_META.operations,
  ROLE_META.branch_manager,
  ROLE_META.owner,
];

export function roleMeta(role: Role): RoleMeta {
  return ROLE_META[role] ?? ROLE_META.cashier;
}

/** أدوات لون مشتقة من طبقة الدور (إداري / موظف) لاستخدامها في واجهة معاينة الأدوار */
export function roleTierIconTone(role: Role): string {
  return roleMeta(role).tier === "management" ? "text-primary-600" : "text-accent-700";
}

export function roleTierSoftBadge(role: Role): string {
  return roleMeta(role).tier === "management"
    ? "bg-primary-100 text-primary-700"
    : "bg-accent-100 text-accent-700";
}